import { ForwardedRef, forwardRef } from "react";
import styles from "./Checkbox.module.scss";

interface IProps {
    defaultChecked?: boolean;
    id: string;
    name: string;
    label?: string;
    onClick?: () => void;
}

const Checkbox = forwardRef<HTMLInputElement, IProps>((props: IProps, ref?: ForwardedRef<HTMLInputElement>) => {
    return (
        <div className={styles.container}>
            <label htmlFor={props.id}>
                <input
                    ref={ref}
                    type="checkbox"
                    onClick={props.onClick}
                    defaultChecked={props.defaultChecked}
                    name={props.name}
                    id={props.id}
                />
                {props.label ?? <>&nbsp;</>}
            </label>
        </div>
    );
});

export default Checkbox;